import { useEffect } from 'react'

const APP_TITLE = 'Michaels - Category Assortment Tool'

/** Sets the browser tab title while the calling page is shown. */
export function useDocumentTitle(...parts: (string | null | undefined)[]) {
  const title = [...parts.filter(Boolean), APP_TITLE].join(' · ')
  useEffect(() => {
    document.title = title
    return () => {
      document.title = APP_TITLE
    }
  }, [title])
}
